export default __webpack_public_path__ + "static/media/kanipakam-temple-preloader.6fb6ffee.gif";